module.exports = __webpack_public_path__ + "static/media/rt-small.fba896c8.png";